import { useState, useCallback } from 'react';

// Services

import ClientsService from '../services/clients.service';

export default function GetIncomeDeclarationClientFile() {
    const [getIncomeDeclarationFileIsLoading, setGetIncomeDeclarationFileIsLoading] = useState(false);
    const [getIncomeDeclarationFileError, setGetIncomeDeclarationFileError] = useState(null);
    const [incomeDeclarationFile, setincomeDeclarationFile] = useState([]);

    // Generate Income Declaration

    const handleGetIncomeDeclarationFile = useCallback(async (id) => {
        setGetIncomeDeclarationFileIsLoading(true);
        setGetIncomeDeclarationFileError(null);

        try {
            const request = await ClientsService.generateIncomeDeclarationPDF(id);

            setGetIncomeDeclarationFileIsLoading(false);
            setGetIncomeDeclarationFileError(null);
            setincomeDeclarationFile(request?.data);
    
        } catch(error) {

            setGetIncomeDeclarationFileIsLoading(false);
            setGetIncomeDeclarationFileError(error.response?.data?.message || error.message);

        }
    }, []);

    return {
        getIncomeDeclarationFileIsLoading,
        getIncomeDeclarationFileError,
        incomeDeclarationFile,
        handleGetIncomeDeclarationFile,
    }
}
